import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import ReactGA from 'react-ga4';

const ProviderProfile = () => {
    useEffect(() => {
        ReactGA.send({
            hitType: 'pageview',
            page: window.location.pathname,
            title: 'ProviderProfile',
        });
    }, []);

    return (
        <Box
            component="main"
            sx={{
                width: '100%',
                boxSizing: 'border-box',
                display: 'flex',
                justifyContent: 'center',
                mt: 7,
                p: 2,
            }}
        >
            <Outlet />
        </Box>
    );
};

export default ProviderProfile;
